import { Card, Container, Input, FormButton, Text, Checkbox, Box } from "../components/UI"
import { useForm, Controller } from "react-hook-form";
import { Link } from "react-router-dom";
import { APP_SETTINGS } from "../hooks/useAppSettings";
import { useController } from "../hooks/useController";
import { Classes } from "../theme/Classes";
import { useEffect, useState } from "react";
import { useUserData } from "../hooks/useUserData";
import { useNavigate } from "react-router-dom";


export const SignIn = () => {
    const { handleSubmit, control, formState: { errors } } = useForm({ mode: 'onChange' });
    const {login: loginUser, response,data, error, isLoading} = useController();
    const {isAuthenticated, setToken, setIsAuthenticated, lang} = useUserData();
    const [isWrongUser, setIsWrongUser] = useState(false);
  
  const navigate = useNavigate();
  useEffect(() => {  
    if(isAuthenticated){
        navigate('/YourAccount');
    }
  }, [isAuthenticated]);

    const onSubmit = data => {
        login(data);
    }
    const login = async (data) =>{
        await loginUser(data.email, data.password);
    }

    useEffect(()=>{
        if(response?.ok ){
            if(data?.access_token){
            console.log(data);
            setIsAuthenticated(true);
            setToken(
                {
                    access_token:  data?.access_token
                    ,expires_in: data?.expires_in
                }
                
            ); 
            localStorage.setItem('token', data?.access_token);
            localStorage.setItem('token_expires_on', data?.expires_in);
            navigate('/YourAccount');
            }
        } else {
            if( response != undefined)
            setIsWrongUser(true);
        }
    },[data, response])

    return (
        <Container>
             <Box display="columnCenter">
            <Card>
                <Text role="h1">{lang?.signIn}</Text>
               
                    <Controller
                        name="email"
                        control={control}
                        rules={{
                            required: true,

                            pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: lang?.invalidEmail
                            }
                        }}

                        render={({ field }) => <Input props={field} placeholder={lang.email} />}
                    />

                    {errors.email && errors.email.type === "required" && (
                        <Text role="validationMessage">{lang?.emailRequired}</Text>
                    )}
                    {errors.email && errors.email.type !== "required" && (
                        <Text role="validationMessage">{errors.email.message}</Text>
                    )}
                    <Controller
                        name="password"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => <Input type="password" placeholder="Password" props={field} />}
                    />
                    {errors.password && <Text role="validationMessage" >{errors.password?.type}</Text>}
                    <button style={{...Classes.Button.Secondary}} title="Log In" onClick={handleSubmit(onSubmit)}>
                    {lang?.signIn}
                    </button>
                    {(isWrongUser) && <><p style={{color:'red'}}>{lang?.emailPasswordNotCorrect}</p></>}
                    
                
                <Text>{lang?.newToNoLine} <Link to={`register`}>{lang?.signUpNow}.</Link> </Text>
                <Text>{lang?.forgotYourPassword} <Link to={`ResetPasswordStep1`}>{lang?.clickHere}.</Link> </Text>
            </Card>
            </Box>
        </Container>
    )
}